import { IFieldsState } from '../../types/fieldsState';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EFieldsStateActionTypes {
  SetFieldsState = 'fieldsState/setState',
}

export type TSetFieldsState = ITypedReduxAction<EFieldsStateActionTypes.SetFieldsState, Partial<IFieldsState>>;

export type TFieldsStateActions = TSetFieldsState;
